"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  IAuthenticationContext: true
};
Object.defineProperty(exports, "IAuthenticationContext", {
  enumerable: true,
  get: function () {
    return _context.IAuthenticationContext;
  }
});
var _createContext = require("./createContext");
Object.keys(_createContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createContext[key];
    }
  });
});
var _context = require("./context");